import { Injectable } from '@angular/core';

import { AppConfig } from '../app.config';
import { throwError } from 'rxjs';
import { filter, map, catchError } from 'rxjs/operators';
import { HelpersService } from './helpers.service';
import { HttpClient } from '@angular/common/http';
import { ErrorHandlerService } from './errorhandler.service';// Add this for error feedback
 
@Injectable({
  providedIn: 'root',
})
export class ReferralService {
  private env: any;
  private apiURL: string = '';

  constructor(
    private http: HttpClient,
    private appConfig: AppConfig,
    private helpersService: HelpersService, 
    private errorHandler: ErrorHandlerService,// Add this for error feedback
  ) {
    this.apiURL = this.appConfig.getEnvironment();
    this.env = this.appConfig.getEnvironmentNew();
  }

  getReferrals(partnerId: string) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .get(
        this.env.url + '/referrals/' + partnerId + '?code=' + this.env.key,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }

  saveReferral(data: any, partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .post(
        this.env.url + '/referrals/' + partnerID + '?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  updateReferral(data: any, partnerID) {
    const headers = this.helpersService.getNewApiHeaders();
    return this.http
      .put(
        this.env.url + '/referrals/' + partnerID + '?code=' + this.env.key,
        data,
        headers,
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.json());
        }),
      );
  }

  getServiceStatuses() {
    let requestOptions = this.helpersService.getAuthenticatedRequestOptions();

    return this.http
      .get(this.apiURL + '/api/Lookup/lstServiceStatus', requestOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((res: any) => {
          return throwError(res.statusText);
        }),
      );
  }
}
